const NAV = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Experience", href: "#experience" },
  { label: "Projects", href: "#projects" },
  { label: "Skills", href: "#skills" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-cream/10 bg-navy pb-10 pt-16 text-cream"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="flex items-center gap-2.5 font-display text-2xl font-semibold tracking-tight">
              <span className="block h-2.5 w-2.5 bg-rust" aria-hidden="true" />
              Kaizen Labs
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-cream/60">
              Development-ready software documentation that bridges business
              intent and engineering execution.
            </p>
          </div>
          <nav className="md:col-span-4" aria-label="Footer navigation">
            <p className="text-xs font-medium uppercase tracking-[0.2em] text-cream/45">
              Navigate
            </p>
            <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2.5">
              {NAV.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-sm text-cream/70 transition-colors hover:text-cream"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <div className="md:col-span-3">
            <p className="text-xs font-medium uppercase tracking-[0.2em] text-cream/45">
              Contact
            </p>
            <a
              href="mailto:vk@kaizenlabsco.com"
              data-testid="footer-email-link"
              className="mt-4 inline-block text-sm text-cream/80 transition-colors hover:text-rust"
            >
              vk@kaizenlabsco.com
            </a>
            <p className="mt-4 text-sm text-cream/50">
              Available for remote consulting worldwide.
            </p>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-cream/10 pt-8 text-xs text-cream/45 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 Kaizen Labs</p>
          <p>Business Analysis • Product Ownership • Product Strategy • Agile Delivery</p>
        </div>
      </div>
    </footer>
  );
}
